// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__xg-Qu","modalForm":"UpgradeEpcsModal_modalForm__2huz6","modalFooter":"UpgradeEpcsModal_modalFooter__JjgQs"};